/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import { ContextProvider } from '@ba-ui-toolkit/context';

import './HighContrastDetect.scss';

// Track the instance could such that we only are applying the class to the body once.
let instanceCount = 0;

let highContrast = false;

function detectHighContrast() {
	const oDiv = document.createElement('div');
	oDiv.className = 'ba-common-hcDetect';

	const oBody = document.body;
	oBody.appendChild(oDiv);

	const styles = window.getComputedStyle(oDiv);
	const oValues = {
		borderTopColor: styles.borderTopColor,
		borderLeftColor: styles.borderLeftColor,
		backgroundImage: styles.backgroundImage,
	};
	if (
		oValues.borderTopColor === oValues.borderLeftColor ||
		(oValues.backgroundImage && oValues.backgroundImage.indexOf('data:image') === -1)
	) {
		highContrast = true;
	}
	oDiv.parentNode.removeChild(oDiv);
}

export default class HighContrastDetect extends Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
	};

	componentDidMount() {
		if (instanceCount === 0 && document) {
			detectHighContrast();
			if (highContrast) {
				document.body.classList.add('ba--highContrast');
			}
		}
		instanceCount += 1;
	}

	componentWillUnmount() {
		instanceCount -= 1;
		if (instanceCount === 0 && document && highContrast) {
			document.body.classList.remove('ba--highContrast');
		}
	}

	render() {
		return (
			<ContextProvider highContrast={highContrast}>
				{Children.only(this.props.children)}
			</ContextProvider>
		);
	}
}
